import React from 'react';

/**
 * Authentication error screen components
 * These provide consistent error messaging across all auth-protected components
 */

export const InvalidTokenScreen = () => (
  <div className="alert alert-danger alert-centered" role="alert">
    <h4 className="alert-heading">Invalid Authentication Link</h4>
    <p>The authentication link you&apos;re using is not valid. This could happen if:</p>
    <ul>
      <li>The link was copied incorrectly</li>
      <li>The link has been modified</li>
      <li>The link format is incorrect</li>
    </ul>
    <p>
      <strong>Please request a new link from your representative.</strong>
    </p>
  </div>
);

export const ExpiredTokenScreen = () => (
  <div
    className="alert alert-warning alert-centered"
    style={{ border: '1px solid darkgoldenrod' }}
    role="alert"
  >
    <h4 className="alert-heading">Link Has Expired</h4>
    <p>The authentication link you&apos;re using has expired for security reasons.</p>
    <p>
      <strong>Please request a new link from your representative to continue.</strong>
    </p>
  </div>
);

export const MissingTokenScreen = () => (
  <div className="alert alert-info alert-centered" role="alert">
    <h4 className="alert-heading">Access Link Required</h4>
    <p>This page requires a secure access link to view.</p>
    <p>
      <strong>
        Please access this page through the link provided in your email or by your representative.
      </strong>
    </p>
  </div>
);
